import { render, staticRenderFns } from "./SieveAccountForm.vue?vue&type=template&id=277808f4&scoped=true"
import script from "./SieveAccountForm.vue?vue&type=script&lang=js"
export * from "./SieveAccountForm.vue?vue&type=script&lang=js"
import style0 from "./SieveAccountForm.vue?vue&type=style&index=0&id=277808f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277808f4",
  null
  
)

export default component.exports